export { ExamesDeUsuario } from './ExamesDeUsuario'
